import { loadStripe } from "@stripe/stripe-js";
import { getEnvs } from "./env";

const { MOZIO_PUBLIC_STRIPE_API_KEY } = getEnvs();

const stripePromise = loadStripe(MOZIO_PUBLIC_STRIPE_API_KEY);

export const getStripePromise = () => {
  return stripePromise;
};
